import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import User from "@/pcm/store/models/User";
import Country from "@/pcm/store/models/Country";
import ClientPaymentInformation from "@/pcm/store/models/ClientPaymentInformation";
import ClientContract from "@/pcm/store/models/ClientContract";
import NewClient from "@/pcm/store/models/NewClient";

export default class Client extends Model {
    static entity = 'clients';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            user_id: this.attr(null),
            country_id: this.attr(null),
            sign_type: this.string(''),
            name: this.string(''),
            alias: this.string(''),
            email: this.string(null).nullable(),
            address: this.string(null).nullable(),
            zip: this.string(null).nullable(),
            company: this.string(null).nullable(),
            chamber_of_commerce: this.string(null).nullable(),
            vat_number: this.string(null).nullable(),
            youtube_url: this.string(null).nullable(),
            max_downloads_per_day: this.number(null).nullable(),
            revenue_share: this.string(null).nullable(),
            payment_method: this.string('').nullable(),
            has_media_access: this.boolean(false),
            is_invited: this.boolean(false),

            created_at: this.string(''),
            updated_at: this.string(''),

            has_password: this.boolean(false),

            // Relations
            user: this.belongsTo(User, 'user_id'),
            country: this.belongsTo(Country, 'country_id'),
            client_payment_information: this.hasOne(ClientPaymentInformation, 'client_id'),
            client_contracts: this.hasMany(ClientContract, 'client_id'),
            new_client: this.hasOne(NewClient, 'client_id'),
        }
    }

    declare id: number;
    declare user_id: number;
    declare country_id: number;
    declare sign_type: string;
    declare name: string;
    declare alias: string;
    declare email: string | null;
    declare address: string | null;
    declare zip: string | null;
    declare company: string | null;
    declare chamber_of_commerce: string | null;
    declare vat_number: string | null;
    declare revenue_share: string | null;
    declare youtube_url: string | null;
    declare max_downloads_per_day: number | null;
    declare payment_method: string | null;
    declare has_media_access: string;
    declare is_invited: string;
    declare has_password: boolean;
    declare country: Country | null;
    declare client_payment_information: ClientPaymentInformation | null;
    declare client_contracts: Array<ClientContract> | null;
    declare new_client: NewClient | null;
}
